import moment from 'moment';
import React, { Component } from 'react';
import { Table as BootstrapTable, Col, Row } from 'react-bootstrap';

import { IS_VALID } from 'utils';

export default class View extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoadingRelation: false,
			cardType: [],
			excludedCardType: [],
			specificUser: [],
			blacklistedUser: [],
		};

		this.getRelation = this.getRelation.bind(this);
	}

	getRelation() {
		let {
			selectedData,

			getRelation,
		} = this.props;

		if (IS_VALID(selectedData)) {
			this.setState({ isLoadingRelation: true });

			getRelation()
				.then(([cardType, excludedCardType, specificUser, blacklistedUser]) => {
					let cardTypeArray = cardType.map((item) => item.get('name'));
					let excludedCardTypeArray = excludedCardType.map((item) => item.get('name'));

					let specificUserArray = specificUser.map(
						(item) =>
							`${IS_VALID(item.get('memberId')) ? item.get('memberId') : ''} ${
								IS_VALID(item.get('name')) ? item.get('name') : ''
							}`
					);

					let blacklistedUserArray = blacklistedUser.map(
						(item) =>
							`${IS_VALID(item.get('memberId')) ? item.get('memberId') : ''} ${
								IS_VALID(item.get('name')) ? item.get('name') : ''
							}`
					);

					this.setState({
						isLoadingRelation: false,
						cardType: cardTypeArray,
						excludedCardType: excludedCardTypeArray,
						specificUser: specificUserArray,
						blacklistedUser: blacklistedUserArray,
					});
				})
				.catch((err) => {
					console.log('err', err);
					this.setState({ isLoadingRelation: false });
				});
		}
	}

	render() {
		let { isLoadingRelation, cardType, excludedCardType, specificUser, blacklistedUser } =
			this.state;

		let { selectedData } = this.props;

		const GET_VALUE = (key) => {
			if (IS_VALID(selectedData)) {
				let value = '';

				if (key === 'createdAt' || key === 'updatedAt') {
					value = moment(selectedData.get(key)).format('MMM DD, YYYY hh:mm A');
				} else if (key === 'durationStartDate' || key === 'durationEndDate') {
					if (IS_VALID(selectedData.get(key))) {
						value = moment(selectedData.get(key)).format('MMM DD, YYYY hh:mm A');
					}
				} else if (key === 'createdBy' || key === 'updatedBy') {
					if (IS_VALID(selectedData.get(key))) {
						value = selectedData.get(key).get('name') || '';
					}
				} else if (
					key === 'isShowDuration' ||
					key === 'isShowWallet' ||
					key === 'isHideZeroBal' ||
					key === 'isShowRedeem' ||
					key === 'isShowEarnedToday' ||
					key === 'isShowTotalBal' ||
					key === 'isShowHistory'
				) {
					value = (selectedData.get(key) || false).toString();
				} else if (key === 'imageSize') {
					value =
						selectedData.get(key) === 'S'
							? 'Small'
							: selectedData.get(key) === 'L'
							? 'Large'
							: '';
				} else if (IS_VALID(selectedData)) {
					value = selectedData.get(key);
				}

				return value;
			} else {
				return '';
			}
		};

		let image = GET_VALUE('image');

		const data = [
			{
				label: 'Image',
				value:
					image && image !== '' ? (
						<div
							style={{
								maxWidth: '200px',
								maxHeight: '200px',
								height: '200px',
								width: '200px',
								display: 'table-cell',
								verticalAlign: 'middle',
							}}
						>
							<img src={image.url()} width="100%" />
						</div>
					) : (
						''
					),
			},
			{
				label: 'Image Size',
				value: GET_VALUE('imageSize'),
			},
			{
				label: 'Wallet Code',
				value: GET_VALUE('walletCode'),
			},
			{
				label: 'Wallet Name',
				value: GET_VALUE('walletName'),
			},
			{
				label: 'Total Balance Key',
				value: GET_VALUE('totalBalanceKey'),
			},
			{
				label: 'Earned Today Key',
				value: GET_VALUE('earnedTodayKey'),
			},
			{
				label: 'Balance Key',
				value: GET_VALUE('balanceKey'),
			},
			{
				label: 'Sort',
				value: GET_VALUE('sort'),
			},
			{
				label: 'Show Duration',
				value: GET_VALUE('isShowDuration'),
			},
			{
				label: 'Duration Start Date',
				value: GET_VALUE('durationStartDate'),
			},
			{
				label: 'Duration End Date',
				value: GET_VALUE('durationEndDate'),
			},
			{
				label: 'Show Wallet',
				value: GET_VALUE('isShowWallet'),
			},
			{
				label: 'Hide Zero Balance',
				value: GET_VALUE('isHideZeroBal'),
			},
			{
				label: 'Show Redeem',
				value: GET_VALUE('isShowRedeem'),
			},
			{
				label: 'Show Earned Today',
				value: GET_VALUE('isShowEarnedToday'),
			},
			{
				label: 'Show Total Balance',
				value: GET_VALUE('isShowTotalBal'),
			},
			{
				label: 'Show History',
				value: GET_VALUE('isShowHistory'),
			},
		];

		return (
			<BootstrapTable bordered responsive>
				<tbody>
					{data.map(({ label, value }, index) => (
						<tr key={index}>
							<td>
								<b>{label}</b>
							</td>
							<td>{value}</td>
						</tr>
					))}
					<tr>
						<td>
							<b>Card Type</b>
						</td>
						<td>
							{isLoadingRelation ? (
								<i className="fa fa-spinner fa-spin"></i>
							) : (
								<div
									style={{
										maxHeight: '200px',
										overflowY: 'scroll',
									}}
								>
									{cardType.join(', ')}
								</div>
							)}
						</td>
					</tr>
					<tr>
						<td>
							<b>Excluded Card Type</b>
						</td>
						<td>
							{isLoadingRelation ? (
								<i className="fa fa-spinner fa-spin"></i>
							) : (
								<div
									style={{
										maxHeight: '200px',
										overflowY: 'scroll',
									}}
								>
									{excludedCardType.join(', ')}
								</div>
							)}
						</td>
					</tr>
					<tr>
						<td>
							<b>Device Type</b>
						</td>
						<td>{GET_VALUE('deviceType')}</td>
					</tr>
					<tr>
						<td>
							<b>Specific User</b>
						</td>
						<td>
							{isLoadingRelation ? (
								<i className="fa fa-spinner fa-spin"></i>
							) : (
								<div
									style={{
										maxHeight: '200px',
										overflowY: 'scroll',
									}}
								>
									{specificUser.join(', ')}
								</div>
							)}
						</td>
					</tr>
					<tr>
						<td>
							<b>Excluded User</b>
						</td>
						<td>
							{isLoadingRelation ? (
								<i className="fa fa-spinner fa-spin"></i>
							) : (
								<div
									style={{
										maxHeight: '200px',
										overflowY: 'scroll',
									}}
								>
									{blacklistedUser.join(', ')}
								</div>
							)}
						</td>
					</tr>
					<tr>
						<td>
							<b>Created At</b>
						</td>
						<td>{GET_VALUE('createdAt')}</td>
					</tr>
					<tr>
						<td>
							<b>Updated At</b>
						</td>
						<td>{GET_VALUE('updatedAt')}</td>
					</tr>
					<tr>
						<td>
							<b>Created By</b>
						</td>
						<td>{GET_VALUE('createdBy')}</td>
					</tr>
					<tr>
						<td>
							<b>Updated By</b>
						</td>
						<td>{GET_VALUE('updatedBy')}</td>
					</tr>
				</tbody>
			</BootstrapTable>
		);
	}

	componentDidMount() {
		this.getRelation();
	}
}



// WEBPACK FOOTER //
// ./components/EWallet/FormContainer/View.js